import { v4 as uuidv4 } from "uuid";
export class StateModel {
    constructor() {
        this.id = uuidv4();
        this.stateName = "";
        this.stateCode = "";
    }
}
export default class State extends StateModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
